import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-data-grid';
import { CLASS_GRID_TEACHER_NAME_HEIGHT, ROW_BUFFER } from '../constants';

class TeacherRowRenderer extends PureComponent {
    static propTypes = {
        row: PropTypes.object
    }

    setScrollLeft(scrollBy) {
        // if you want freeze columns to work, you need to make sure you implement this as apass through
        this.row.setScrollLeft(scrollBy);
    }

    getComponentReference(currentComponent) {
        this.row = currentComponent;
    }

    render() {
        const height = (this.props.row.classesCount * CLASS_GRID_TEACHER_NAME_HEIGHT) + ROW_BUFFER;

        return (<Row ref={node => this.getComponentReference(node)} {...this.props} height={height} />);
    }
}

export default TeacherRowRenderer;



// WEBPACK FOOTER //
// ./app/components/renderers/teacher-row-renderer/index.js